module.exports = __webpack_public_path__ + "static/img/bannerBg3_en.bbab852.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/bannerBg3_en.png
// module id = N2o/
// module chunks = 1